const themeSettingsDirectTop2 = {
  menu: {
    logoimage: {
      url: null,
      width: null,
      height: null,
      focalpoint: {
        x: 50,
        y: 50,
      },
    },
    show_logo: true,
    title: null,
    menu_icon: true,
    menu_index: true,
    article: false,
    pagination: false,
    shadow: true,
    show_borders: false,
    background_color: '#ffffff',
    color: '#202020',
    scrollMenu: false,
    menuTags: false,
    modalNavigation: false,
    // null = centred window as before; created() sends the merged defaults on
    // mount, so null keeps old magazines byte-equal (spec 2026-10-02 §2.2).
    modalDisplay: null,
    hideNavOnScroll: false,
    hideNavScrollOnlyOnMobile: false,
    hideMenu: false,
  },
  sideMenu: {
    menu_icon: true,
    menu_index: true,
    showTaggedSubArticles: false,
  },
  menuButtons: {
    mobile_dropdown: true,

    activate_search: false,
    search_tooltip: null,
    search_showOnMobile: false,

    activate_cookies: false,
    cookies_tooltip: null,
    cookies_showOnMobile: false,

    activate_sharing: false,
    sharing_tooltip: null,
    sharing_showOnMobile: false,

    activate_intro: false,
    intro_tooltip: null,
    intro_showOnMobile: false,

    activate_languageSwitcher: false,
    languageSwitcher_tooltip: null,
    languageSwitcher_showOnMobile: false,

    activate_facebook: false,
    facebook: null,
    facebook_tooltip: null,
    facebook_showOnMobile: false,

    activate_instagram: false,
    instagram: null,
    instagram_tooltip: null,
    instagram_showOnMobile: false,

    activate_linkedin: false,
    linkedin: null,
    linkedin_tooltip: null,
    linkedin_showOnMobile: false,

    activate_twitter: false,
    twitter: null,
    twitter_tooltip: null,
    twitter_showOnMobile: false,

    activate_tiktok: false,
    tiktok: null,
    tiktok_tooltip: null,
    tiktok_showOnMobile: false,

    activate_bluesky: false,
    bluesky: null,
    bluesky_tooltip: null,
    bluesky_showOnMobile: false,

    activate_xing: false,
    xing: null,
    xing_tooltip: null,
    xing_showOnMobile: false,

    activate_youtube: false,
    youtube: null,
    youtube_tooltip: null,
    youtube_showOnMobile: false,

    activate_website: false,
    website: null,
    website_tooltip: null,
    website_showOnMobile: false,

    activate_print: false,
    print: null,
    print_tooltip: null,
    print_showOnMobile: false,

    activate_overview: false,
    overview: null,
    overview_tooltip: null,
    overview_showOnMobile: false,

    activate_imprint: false,
    imprint: null,
    imprint_tooltip: null,
    imprint_showOnMobile: false,

    activate_dataprivacy: false,
    dataprivacy: null,
    dataprivacy_tooltip: null,
    dataprivacy_showOnMobile: false,

    activate_custom1: false,
    custom1: null,
    custom1_tooltip: null,
    custom1_icon: 'fa-heart',
    custom1_showOnMobile: false,
    custom1_openInNewTab: false,
    custom1_openInModal: false,
    custom1_modalSize: null,
    custom1_modalCentered: false,
    activate_custom2: false,
    custom2: null,
    custom2_tooltip: null,
    custom2_icon: 'fa-heart',
    custom2_showOnMobile: false,
    custom2_openInNewTab: false,
    custom2_openInModal: false,
    custom2_modalSize: null,
    custom2_modalCentered: false,

    custom_button_1: {
      activate: false,
      showOnMobile: false,
      openInNewTab: false,
      url: null,
      text: null,
    },
    custom_button_2: {
      activate: false,
      showOnMobile: false,
      openInNewTab: false,
      url: null,
      text: null,
    },
  },
  articleSettings: {
    activate_width: false,
    maxWidth: null,
    maxWidthBackgroundColor: null,
  },
  navigationArrow: {
    navigation: true,
    navigation_hide: false,
    navigation_position: false,
    showNavigationOnMobile: true,
    showNavigationAtSides: false,
  },
  navigationWidget: {
    activate_pagination: false, // here it is called pagination
    showPaginationDesktop: false,
    hidePaginationOnScroll: false,
  },
  bottomNavigationBar: {
    showBottomNavigationBar: false,
    useStepsMenu: false,
    stepsDisplayMode: 'dots',
    stepsBackgroundColor: '#ffffff',
    stepsTrackColor: '#e5e5e5',
    stepsDotColor: '#cccccc',
    stepsActiveDotColor: '#f5c518',
    stepsArrowBackgroundColor: '#f5c518',
    stepsArrowIconColor: '#202020',
    stepsArrowIconColorPrev: '#202020',
    stepsArrowIconColorNext: '#202020',
    stepsArrowBorderColor: '#e5e5e5',
    backgroundColor: '#ffffff',
    activeBackgroundColor: '#cccccc',
    showOnDesktop: false,
    desktopPosition: 'right',
    styleVariant: 'A',
    showMoreButton: false,
    showMoreButtonNumber: '4',
    showMoreButtonNumberDesktop: '6',
    showMoreButtonLabel: 'More',
    hideIconsOnMobile: false,
    hideLabelsOnMobile: false,
    hideOnScroll: false,
    topValueOnDesktop: 100,
    data: [],
  },
};

export default themeSettingsDirectTop2;
